import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fetchWebsiteSettingsRequest } from '../api/websiteSettings';

const WebsiteSettingsContext = createContext(null);

export const useWebsiteSettings = () => {
  const context = useContext(WebsiteSettingsContext);
  if (!context) {
    // Return default values if context is not available
    return {
      websiteSettings: null,
      loading: false,
      error: null,
    };
  }
  return context;
};

export const WebsiteSettingsProvider = ({ children }) => {
  const [websiteSettings, setWebsiteSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const response = await fetchWebsiteSettingsRequest();
        setWebsiteSettings(response.data?.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching website settings:', err);
        setError(err);
        setWebsiteSettings(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const value = {
    websiteSettings,
    loading,
    error,
  };

  return (
    <WebsiteSettingsContext.Provider value={value}>
      {children}
    </WebsiteSettingsContext.Provider>
  );
};

WebsiteSettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
